import type { BoardDiagramV3, LvMatch } from "./types";

interface SetBoardItemLvMatchInDiagramArgs {
  diagram: BoardDiagramV3;
  diagramItemTypeId: number;
  lvMatch: LvMatch;
}

export const setBoardItemLvMatchInDiagram = ({
  diagram,
  diagramItemTypeId,
  lvMatch,
}: SetBoardItemLvMatchInDiagramArgs): BoardDiagramV3 => {
  const targetIndex = diagram.itemTypes.findIndex(
    (itemType) => itemType.diagram_item_type_id === diagramItemTypeId,
  );
  if (targetIndex === -1) return diagram;

  const itemTypes = [...diagram.itemTypes];
  itemTypes[targetIndex] = { ...itemTypes[targetIndex], lvMatch };

  return { ...diagram, itemTypes };
};
